import React, { useState } from "react";
import { getItemsGroup } from "../../utils/url";

export default function ({ item, showTopicName }) {
  const [showMore, setShowMore] = useState(false);

  return (
    <span>
      {item.topics && item.topics.length > 0 ? (
        <span>
          {!showMore && (
            <span>
              <div className="storyTopics">{showTopicName(item.topics[0])}</div>
            </span>
          )}

          <span className="cursor-pointer">
            {!showMore ? (
              <span onClick={() => setShowMore(true)}>
                {" "}
                {item.topics.length - 1} +{" "}
              </span>
            ) : (
              <span>
                {item.topics.map((topic, idx) => {
                  return (
                    <div className="storyTopics" key={idx}>
                      {showTopicName(topic)}
                    </div>
                  );
                })}
                <span onClick={() => setShowMore(false)}> - Show less </span>{" "}
              </span>
            )}
          </span>
        </span>
      ) : (
        ""
      )}
    </span>
  );
}
